var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Ordercontent" },
    [
      _c(
        "van-tabs",
        {
          on: { click: _vm.changeTab },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        },
        [
          _c(
            "van-tab",
            { attrs: { title: "已开具发票" } },
            [
              _vm.dataList.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.dataList, function(item, i) {
                      return _c("div", { key: i }, [
                        item.status == 1
                          ? _c(
                              "a",
                              {
                                staticClass: "billBar",
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.gotoInvoicing(item)
                                  }
                                }
                              },
                              [
                                _c(
                                  "van-row",
                                  [
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "title",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _vm._v(_vm._s(item.ghdwmc)),
                                        _c("span", { staticClass: "address" }, [
                                          _vm._v(_vm._s(item.address))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "cont",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "money",
                                            attrs: { span: "24" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "orange" },
                                              [
                                                _vm._v(
                                                  "¥ " + _vm._s(item.money)
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t增值税电子普通发票"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "info",
                                            attrs: { span: "16" }
                                          },
                                          [_vm._v("订单信息 >>")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "info",
                                            attrs: { span: "8" }
                                          },
                                          [_vm._v(_vm._s(item.createTime))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dataList.length == 0 || _vm.num1 == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("暂无已开具发票信息！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-tab",
            { attrs: { title: "申请中发票" } },
            [
              _vm.dataList.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.dataList, function(item, i) {
                      return _c("div", { key: i }, [
                        item.status == 0
                          ? _c(
                              "a",
                              {
                                staticClass: "billBar",
                                attrs: { href: "javascript:;" }
                              },
                              [
                                _c(
                                  "van-row",
                                  [
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "title",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _vm._v(_vm._s(item.ghdwmc)),
                                        _c("span", { staticClass: "address" }, [
                                          _vm._v(_vm._s(item.address))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "cont",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "money",
                                            attrs: { span: "24" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "orange" },
                                              [
                                                _vm._v(
                                                  "¥ " + _vm._s(item.money)
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t增值税电子普通发票"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "info",
                                            attrs: { span: "16" }
                                          },
                                          [_vm._v("订单信息 >>")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "info",
                                            attrs: { span: "8" }
                                          },
                                          [_vm._v(_vm._s(item.createTime))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dataList.length == 0 || _vm.num2 == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("暂无申请中发票信息！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73a7d56f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73a7d56f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/invoicing/invoicingList.vue
// module id = null
// module chunks = 